import type {
  Aggregations,
  Client,
  ClientsPlaces,
  Place,
  Project,
  RouterViewMode,
  Unit,
} from "@/types";
import type { RouterState } from "@/types/store";
import type { MutationTree } from "vuex";

export const SET_VIEW_MODE = "SET_VIEW_MODE";

// CLIENTS
export const LOAD_CLIENTS = "LOAD_CLIENTS";
export const LOAD_CLIENTS_SUCCESS = "LOAD_CLIENTS_SUCCESS";
export const LOAD_CLIENTS_FAILURE = "LOAD_CLIENTS_FAILURE";

// PLACES
export const LOAD_PLACES = "LOAD_PLACES";
export const LOAD_PLACES_SUCCESS = "LOAD_PLACES_SUCCESS";
export const LOAD_PLACES_FAILURE = "LOAD_PLACES_FAILURE";

// PROJECT
export const LOAD_PROJECTS = "LOAD_PROJECTS";
export const LOAD_PROJECTS_SUCCESS = "LOAD_PROJECTS_SUCCESS";
export const LOAD_PROJECTS_FAILURE = "LOAD_PROJECTS_FAILURE";

// CLIENT PLACE
export const LOAD_CLIENTS_PLACES = "LOAD_CLIENTS_PLACES";
export const LOAD_CLIENTS_PLACES_SUCCESS = "LOAD_CLIENTS_PLACES_SUCCESS";
export const LOAD_CLIENTS_PLACES_FAILURE = "LOAD_CLIENTS_PLACES_FAILURE";
// AGGREGATIONS
export const LOAD_AGGREGATIONS = "LOAD_AGGREGATIONS";
export const LOAD_AGGREGATIONS_SUCCESS = "LOAD_AGGREGATIONS_SUCCESS";
export const LOAD_AGGREGATIONS_FAILURE = "LOAD_AGGREGATIONS_FAILURE";
// UNITS
export const LOAD_UNITS = "LOAD_UNITS";
export const LOAD_UNITS_SUCCESS = "LOAD_UNITS_SUCCESS";
export const LOAD_UNITS_FAILURE = "LOAD_UNITS_FAILURE";

export const mutations: MutationTree<RouterState> = {
  [SET_VIEW_MODE](state: RouterState, viewMode: RouterViewMode) {
    state.viewMode = viewMode;
  },

  // AGGREGATIONS
  [LOAD_AGGREGATIONS](state: RouterState) {
    state.aggregations = { ...state.aggregations, loading: true, error: null };
  },
  [LOAD_AGGREGATIONS_SUCCESS](
    state: RouterState,
    aggregations: Aggregations[],
  ) {
    state.aggregations = { data: aggregations, loading: false, error: null };
  },
  [LOAD_AGGREGATIONS_FAILURE](state: RouterState, error: string) {
    state.aggregations = {
      ...state.aggregations,
      loading: false,
      error: error,
    };
  },

  // LOAD UNITS
  [LOAD_UNITS](state: RouterState) {
    state.units = {
      ...state.units,
      loading: true,
      error: null,
    };
  },
  [LOAD_UNITS_SUCCESS](state: RouterState, units: Unit[]) {
    state.units = {
      data: [...units],
      loading: false,
      error: null,
    };
  },
  [LOAD_UNITS_FAILURE](state: RouterState, error: string) {
    state.units = {
      ...state.units,
      loading: false,
      error: error,
    };
  },

  // CLIENTS
  [LOAD_CLIENTS](state: RouterState) {
    state.clients = { ...state.clients, loading: true, error: null };
  },
  [LOAD_CLIENTS_SUCCESS](state: RouterState, clients: Client[]) {
    state.clients = { data: clients, loading: false, error: null };
  },
  [LOAD_CLIENTS_FAILURE](state: RouterState, error: string) {
    state.clients = { ...state.clients, loading: false, error: error };
  },

  // PLACES
  [LOAD_PLACES](state: RouterState) {
    state.places = { ...state.places, loading: true, error: null };
  },
  [LOAD_PLACES_SUCCESS](state: RouterState, places: Place[]) {
    state.places = { data: places, loading: false, error: null };
  },
  [LOAD_PLACES_FAILURE](state: RouterState, error: string) {
    state.places = { ...state.places, loading: false, error: error };
  },

  // PROJECTS
  [LOAD_PROJECTS](state: RouterState) {
    state.projects = { ...state.projects, loading: true, error: null };
  },
  [LOAD_PROJECTS_SUCCESS](state: RouterState, projects: Project[]) {
    state.projects = { data: projects, loading: false, error: null };
  },
  [LOAD_PROJECTS_FAILURE](state: RouterState, error: string) {
    state.projects = { ...state.projects, loading: false, error: error };
  },

  // CLIENTS & PLACES
  [LOAD_CLIENTS_PLACES](state: RouterState) {
    state.clientsPlaces = {
      ...state.clientsPlaces,
      loading: true,
      error: null,
    };
  },
  [LOAD_CLIENTS_PLACES_SUCCESS](
    state: RouterState,
    clientsPlaces: ClientsPlaces[],
  ) {
    state.clientsPlaces = { data: clientsPlaces, loading: false, error: null };
  },
  [LOAD_CLIENTS_PLACES_FAILURE](state: RouterState, error: string) {
    state.clientsPlaces = {
      ...state.clientsPlaces,
      loading: false,
      error: error,
    };
  },
};
